<div id="intro-sec" class="intro-sec">
    <div class="loading-sec">
        <div #nameIntro class="logo">SAHARAT STUDIO</div>
        <div #loadingBar class="loading-bar">
            <div #progress class="loading-progress"></div>
        </div>
    </div>
</div>